import * as React from 'react'
import find from 'lodash/find'
import {useParams} from 'react-router'
import {mutate as globalMutate} from 'swr'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'

import {fromJust} from '@freckle/maybe'

import SpinnerWrapper from '@frontrow/console/src/components/common/spinner-wrapper'
import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import EditItem from '@frontrow/console/src/components/pages/piggy-store-page/edit-item/edit-item'

import {patchItem, type ItemParamsT} from '@frontrow/console/src/helpers/api-items'

import {usePiggyStore, PIGGY_STORE_SWR_KEY} from '@frontrow/console/src/hooks/api'

export function EditItemContainer(): React.ReactElement {
  const params = useParams<{itemId: string}>()
  const pathItemId = fromJust(params.itemId, 'Cannot find itemId in URL')
  const itemId = parseInt(pathItemId, 10)

  const {data, isLoading, error} = usePiggyStore()

  const updateItem = React.useCallback(async (itemId: number, updateParams: ItemParamsT) => {
    try {
      await patchItem(itemId, updateParams)
      // Revalidate the piggy store data after successful update
      await globalMutate(PIGGY_STORE_SWR_KEY)
    } catch (err) {
      const apiError = firstResponseApiError(err)
      throw new Error(apiError.message)
    }
  }, [])

  const items = data?.itemsData || []
  const item = find(items, item => item.id === itemId)
  const storeCategoryVariations = data?.storeCategoryVariations

  const errorMessage = error?.message || error

  const editItemNode =
    item !== null && item !== undefined && storeCategoryVariations ? (
      <EditItem
        item={item}
        error={errorMessage}
        updateItem={updateItem}
        storeCategoryVariations={storeCategoryVariations}
      />
    ) : (
      <ErrorAlert>Could not find item with id {itemId}</ErrorAlert>
    )

  return <SpinnerWrapper isLoading={isLoading}>{editItemNode}</SpinnerWrapper>
}
